<app-form-view [formDataModel]="crmDepartmentData"
    [formItems]="crmDepartmentFormItems"
    [showAddMore]="showAddMore"
    (onSave)="onSaveClicked($event)"
    (onCancel)="onCancelClicked($event)"
    (onAddMore)="onAddMoreClicked($event)"></app-form-view>
